import React from 'react'
import PropTypes from 'prop-types'

import { Like, Back, Info2, Edit, Bubbles, Paper, Leaf, Bag, Close } from './Svg'

import PolovinkiProduct from './PolovinkiProduct'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      quantity: 1,
      price: 0,
      selectedIngredients: {}, // Теперь это объект {ingredientId: quantity}
      selectedAntiIngredients: {}, // Антиингредиенты («можно убрать») {ingredientId: 1}
      selectedVibor: null, // Выбранный ингредиент из vibor
      selectedViborMas: {}, // Выбранные ингредиенты из vibor_mas {groupId: {itemId: quantity}}
      showIngredientsModal: false,
      show_all: false,
      showInfoModal: false, // Добавляем состояние для окна информации
      infoModalAnimating: false // Добавляем состояние для анимации
    }
  }

  calculatePrice = (
    quantity = this.state.quantity, 
    selectedIngredients = this.state.selectedIngredients, 
    selectedVibor = this.state.selectedVibor,
    selectedViborMas = this.state.selectedViborMas
  ) => {
    const unitPrice = this.props.product?.data?.price || 0
    const ingredientsPrice = Object.entries(selectedIngredients).reduce((sum, [ingId, ingQuantity]) => {
      const ingredient = this.getIngredientById(ingId);
      return sum + (ingredient?.price || 0) * ingQuantity;
    }, 0)
    
    // Добавляем цену выбранного ингредиента из vibor
    const viborPrice = selectedVibor ? (selectedVibor.price || 0) : 0;
    
    // Добавляем цены выбранных ингредиентов из vibor_mas
    const viborMasPrice = Object.values(selectedViborMas).reduce((sum, groupSelections) => {
      return sum + Object.entries(groupSelections).reduce((groupSum, [itemId, itemQuantity]) => {
        const item = this.getViborMasItemById(itemId);
        return groupSum + (item?.price || 0) * itemQuantity;
      }, 0);
    }, 0);
    
    return (unitPrice + ingredientsPrice + viborPrice + viborMasPrice) * quantity
  }

  showAll = () => {
    this.setState({
      show_all: true
    })
  }

  componentDidMount() {
    if (this.props.product?.data?.price) {
      const { vibor, vibor_mas } = this.props.product.data;
      
      // Устанавливаем первый ингредиент из vibor как выбранный по умолчанию, если есть
      let defaultVibor = null;
      if (vibor && vibor.length > 0) {
        defaultVibor = vibor[0];
      }

      // Устанавливаем первые элементы из каждой группы vibor_mas как выбранные по умолчанию
      let defaultViborMas = {};
      if (vibor_mas && vibor_mas.length > 0) {
        vibor_mas.forEach(group => {
          if (group.list && group.list.length > 0) {
            const firstItem = group.list[0];
            defaultViborMas[group.name] = {
              [firstItem.id]: 1
            };
          }
        });
      }

      const price = this.calculatePrice(1, {}, defaultVibor, defaultViborMas)
      this.setState({
        price: price,
        quantity: 1,
        selectedIngredients: {},
        selectedAntiIngredients: {},
        selectedVibor: defaultVibor,
        selectedViborMas: defaultViborMas
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product?.data?.id !== this.props.product?.data?.id) {
      const { vibor, vibor_mas } = this.props.product?.data || {};
      
      // Устанавливаем первый ингредиент из vibor как выбранный по умолчанию, если есть
      let defaultVibor = null;
      if (vibor && vibor.length > 0) {
        defaultVibor = vibor[0];
      }

      // Устанавливаем первые элементы из каждой группы vibor_mas как выбранные по умолчанию
      let defaultViborMas = {};
      if (vibor_mas && vibor_mas.length > 0) {
        vibor_mas.forEach(group => {
          if (group.list && group.list.length > 0) {
            const firstItem = group.list[0];
            defaultViborMas[group.name] = {
              [firstItem.id]: 1
            };
          }
        });
      }

      const price = this.calculatePrice(1, {}, defaultVibor, defaultViborMas)
      this.setState({
        price: price,
        quantity: 1,
        selectedIngredients: {},
        selectedVibor: defaultVibor,
        selectedViborMas: defaultViborMas,
        selectedAntiIngredients: {},
        showInfoModal: false, // Сбрасываем состояние при смене товара
        infoModalAnimating: false
      })
    }
  }

  handleQuantityChange = (newQuantity) => {
    if (newQuantity < 1) return
    
    const price = this.calculatePrice(
      newQuantity, 
      this.state.selectedIngredients, 
      this.state.selectedVibor,
      this.state.selectedViborMas
    )
    this.setState({
      quantity: newQuantity,
      price: price
    })
  }

  incrementQuantity = () => {
    this.handleQuantityChange(this.state.quantity + 1)
  }

  decrementQuantity = () => {
    this.handleQuantityChange(this.state.quantity - 1)
  }

  changeProduct = ( id ) => {
    const { openProductWin } = this.props
    openProductWin( id, false )
  }

  getIngredientById = (ingredientId) => {
    const { data } = this.props.product || {};
    // Приводим ingredientId к числу для сравнения, так как в массиве ingredienti ID являются числами
    const numericId = parseInt(ingredientId, 10);
    return (data?.ingredienti || []).find(ing => ing?.id === numericId);
  }

  getViborMasItemById = (itemId) => {
    const { data } = this.props.product || {};
    const numericId = parseInt(itemId, 10);
    
    // Ищем item во всех группах vibor_mas
    for (const group of data?.vibor_mas || []) {
      const item = group.list.find(item => item?.id === numericId);
      if (item) return item;
    }
    
    return null;
  }

  getIngredientiLimit = () => {
    return this.props.product?.data?.ingredienti_limit || 0;
  }

  getSelectedIngredientsTotalQuantity = () => {
    // Суммируем quantity всех выбранных ингредиентов
    return Object.values(this.state.selectedIngredients).reduce((sum, qty) => sum + qty, 0);
  }

  isIngredientiLimitReached = () => {
    const limit = this.getIngredientiLimit();
    if (limit <= 0) return false;
    return this.getSelectedIngredientsTotalQuantity() >= limit;
  }

  toggleIngredient = (ingredientId) => {
    if (!ingredientId) return;

    const { selectedIngredients, quantity, selectedVibor, selectedViborMas } = this.state
    const isSelected = selectedIngredients.hasOwnProperty(ingredientId)

    // Если лимит достигнут и ингредиент ещё не выбран — не даём добавить
    if (!isSelected && this.isIngredientiLimitReached()) return;

    let newSelectedIngredients
    if (isSelected) {
      // Удаляем ингредиент из выбранных
      const { [ingredientId]: removed, ...rest } = selectedIngredients
      newSelectedIngredients = rest
    } else {
      // Добавляем ингредиент с количеством 1
      newSelectedIngredients = {
        ...selectedIngredients,
        [ingredientId]: 1
      }
    }

    const price = this.calculatePrice(quantity, newSelectedIngredients, selectedVibor, selectedViborMas)

    this.setState({
      selectedIngredients: newSelectedIngredients,
      price: price
    })
  }

  // Антиингредиенты («можно убрать») — цена не влияет, id уходит в заказ
  toggleAntiIngredient = (ingredientId) => {
    if (!ingredientId) return;

    const key = ingredientId.toString();
    const { selectedAntiIngredients } = this.state;

    if (selectedAntiIngredients.hasOwnProperty(key)) {
      const { [key]: removed, ...rest } = selectedAntiIngredients;
      this.setState({ selectedAntiIngredients: rest });
    } else {
      this.setState({ selectedAntiIngredients: { ...selectedAntiIngredients, [key]: 1 } });
    }
  }

  changeIngredientQuantity = (ingredientId, newQuantity) => {
    if (newQuantity < 0) return
    
    const { selectedIngredients, quantity, selectedVibor, selectedViborMas } = this.state
    
    if (newQuantity === 0) {
      // Если количество 0, удаляем ингредиент
      const { [ingredientId]: removed, ...newSelectedIngredients } = selectedIngredients
      const price = this.calculatePrice(quantity, newSelectedIngredients, selectedVibor, selectedViborMas)
      this.setState({
        selectedIngredients: newSelectedIngredients,
        price: price
      })
    } else {
      // Обновляем количество ингредиента
      const newSelectedIngredients = {
        ...selectedIngredients,
        [ingredientId]: newQuantity
      }
      const price = this.calculatePrice(quantity, newSelectedIngredients, selectedVibor, selectedViborMas)
      this.setState({
        selectedIngredients: newSelectedIngredients,
        price: price
      })
    }
  }

  incrementIngredientQuantity = (ingredientId) => {
    const currentQuantity = this.state.selectedIngredients[ingredientId] || 0
    const limit = this.getIngredientiLimit();
    // Если лимит установлен и новое общее количество превысит лимит — не даём увеличить
    if (limit > 0) {
      const totalWithoutCurrent = this.getSelectedIngredientsTotalQuantity() - currentQuantity;
      if (totalWithoutCurrent + (currentQuantity + 1) > limit) return;
    }
    this.changeIngredientQuantity(ingredientId, currentQuantity + 1)
  }

  decrementIngredientQuantity = (ingredientId) => {
    const currentQuantity = this.state.selectedIngredients[ingredientId] || 0
    this.changeIngredientQuantity(ingredientId, currentQuantity - 1)
  }

  // Обработчик выбора ингредиента из vibor
  handleViborChange = (viborItem) => {
    const { quantity, selectedIngredients, selectedViborMas } = this.state;
    const price = this.calculatePrice(quantity, selectedIngredients, viborItem, selectedViborMas);
    
    this.setState({
      selectedVibor: viborItem,
      price: price
    });
  }

  // Обработчик выбора ингредиента из vibor_mas
  handleViborMasChange = (groupId, item) => {
    const { quantity, selectedIngredients, selectedVibor, selectedViborMas } = this.state;
    
    const newSelectedViborMas = {
      ...selectedViborMas,
      [groupId]: {
        [item.id]: 1
      }
    };
    
    const price = this.calculatePrice(quantity, selectedIngredients, selectedVibor, newSelectedViborMas);
    
    this.setState({
      selectedViborMas: newSelectedViborMas,
      price: price
    });
  }

  openIngredientsModal = () => {
    this.setState({ showIngredientsModal: true })
  }

  closeIngredientsModal = () => {
    this.setState({ showIngredientsModal: false })
  }

  // Обработчики для окна информации
  openInfoModal = () => {
    this.setState({ 
      showInfoModal: true,
      infoModalAnimating: false // Сначала показываем без анимации
    });
    
    // Задержка для применения анимации после добавления в DOM
    setTimeout(() => {
      this.setState({ 
        infoModalAnimating: true 
      });
    }, 10);
  }

  closeInfoModal = () => {
    this.setState({ 
      infoModalAnimating: false 
    });
    
    // Задержка для завершения анимации перед скрытием
    setTimeout(() => {
      this.setState({ 
        showInfoModal: false 
      });
    }, 300);
  }

  handleAddToCart = () => {
    const { data } = this.props.product || {};
    const { quantity, selectedIngredients, selectedAntiIngredients, selectedVibor, selectedViborMas } = this.state;
    const { id } = data || {};

    if (!id) {
      console.error('Product ID is missing');
      return;
    }

    // Собираем все выбранные ID с количеством 1
    let allSelections = { ...selectedIngredients };
    
    // Добавляем выбранный ингредиент из vibor
    if (selectedVibor) {
      allSelections[selectedVibor.id] = 1;
    }

    // Добавляем выбранные ингредиенты из vibor_mas
    Object.values(selectedViborMas).forEach(groupSelections => {
      const itemId = Object.keys(groupSelections)[0];
      allSelections[itemId] = 1;
    });

    // Добавляем антиингредиенты («можно убрать»)
    Object.keys(selectedAntiIngredients).forEach(antiId => {
      allSelections[antiId] = 1;
    });

    // Преобразуем в строку
    const finalIngredientsString = Object.entries(allSelections)
      .map(([ingId, ingQuantity]) => `${ingId}:${ingQuantity}`)
      .join(',');

    window.console.log( id, quantity, finalIngredientsString )

    this.props.addToCart(id, quantity, finalIngredientsString);
  }

  render() {
    const { product, favorite, changeFavorite, closeProductWin } = this.props,
    { data } = product || {},
    { price, quantity, selectedIngredients, selectedAntiIngredients, selectedVibor, selectedViborMas, showIngredientsModal, show_all, showInfoModal, infoModalAnimating } = this.state

    const ingredients = data?.ingredienti || []
    const hasIngredients = ingredients.length > 0
    const antiingredients = data?.antiingredienti || []
    const hasAntiIngredients = antiingredients.length > 0
    const hasVibor = data?.vibor && data.vibor.length > 0
    const hasViborMas = data?.vibor_mas && data.vibor_mas.length > 0
    const ingredientiLimit = this.getIngredientiLimit();
    const isLimitReached = this.isIngredientiLimitReached();

    // Фильтруем ингредиенты для отображения - те, которые НЕ выбраны
    const availableIngredients = ingredients.filter(ing => 
      ing && ing.id && !selectedIngredients.hasOwnProperty(ing.id.toString())
    );

    // Получаем объекты выбранных ингредиентов с их количеством
    const selectedIngredientObjects = Object.entries(selectedIngredients)
      .map(([id, qty]) => {
        const ingredient = this.getIngredientById(id);
        return ingredient ? { ...ingredient, quantity: qty } : null;
      })
      .filter(Boolean);

    const isPolovinki = data?.polovinki && data.polovinki.length > 0

    if (isPolovinki) {
      return <PolovinkiProduct {...this.props} />
    }

    return (
      <>
        {/* Оверлей */}
        <div
          className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${
            product?.show ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={() => closeProductWin()}
        />
        
        {/* Окно товара — выезжает снизу */}
        <div
          className={`fixed bottom-0 left-1/2 z-50 w-full transition-transform duration-300 ease-out ${
            product?.show ? "translate-y-0" : "translate-y-full"
          }`}
          style={{
            maxWidth: '600px',
            transform: product?.show ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(100%)',
            WebkitTransform: product?.show ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(100%)'
          }}
        >
          <div className='bg-white flex flex-col tracking-tight overflow-y-auto'
            style={{
              borderTopLeftRadius: '25px',
              borderTopRightRadius: '25px',
              marginTop: '20px',
              maxHeight: 'calc(100dvh - 20px)'
            }}
          >
            {/* Шапка с кнопками */}
            <div className='sticky top-0 left-0 w-full px-[10px] pt-[15px] pb-[5px] z-10 bg-white'>
              <div className='flex items-center justify-between'>
                <button
                  onClick={() => closeProductWin()}
                  className="w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center flex-none text-black shadow-lg"
                >
                  <Back />
                </button>
                {data?.measure != '' &&
                  <div className='relative'>
                    <div 
                      className='w-[109px] h-[40px] flex items-center justify-center gap-[7px] cursor-pointer shadow-lg rounded-[25px] bg-white'
                      onClick={this.openInfoModal}
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M18 9C18 13.9707 13.9707 18 9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0C13.9707 0 18 4.0293 18 9ZM9 14.175C9.17902 14.175 9.35071 14.1039 9.4773 13.9773C9.60388 13.8507 9.675 13.679 9.675 13.5V8.1C9.675 7.92098 9.60388 7.74929 9.4773 7.6227C9.35071 7.49612 9.17902 7.425 9 7.425C8.82098 7.425 8.64929 7.49612 8.5227 7.6227C8.39612 7.74929 8.325 7.92098 8.325 8.1V13.5C8.325 13.8726 8.6274 14.175 9 14.175ZM9 4.5C9.23869 4.5 9.46761 4.59482 9.6364 4.7636C9.80518 4.93239 9.9 5.1613 9.9 5.4C9.9 5.63869 9.80518 5.86761 9.6364 6.0364C9.46761 6.20518 9.23869 6.3 9 6.3C8.7613 6.3 8.53239 6.20518 8.3636 6.0364C8.19482 5.86761 8.1 5.63869 8.1 5.4C8.1 5.1613 8.19482 4.93239 8.3636 4.7636C8.53239 4.59482 8.7613 4.5 9 4.5Z" fill="#5A91FF"/>
                      </svg>
                      <div className='text-[14px] text-black font-normal'>О товаре</div>
                    </div>
                    
                    {/* Окно информации о товаре */}
                    {showInfoModal && (
                      <div 
                        className={`w-[335px] rounded-[25px] absolute top-[47px] left-[calc(50%-170px)] bg-[#00000052] backdrop-blur-[51.4px] shadow-lg p-[15px] z-50 transition-all duration-300 ease-in-out ${
                          infoModalAnimating 
                            ? 'opacity-100 transform translate-y-0' 
                            : 'opacity-0 transform -translate-y-2'
                        }`}
                      >
                        <div className='flex items-center justify-between'>
                          <div className='flex items-center gap-[7px] text-[14px] text-white'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M18 9C18 13.9707 13.9707 18 9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0C13.9707 0 18 4.0293 18 9ZM9 14.175C9.17902 14.175 9.35071 14.1039 9.4773 13.9773C9.60388 13.8507 9.675 13.679 9.675 13.5V8.1C9.675 7.92098 9.60388 7.74929 9.4773 7.6227C9.35071 7.49612 9.17902 7.425 9 7.425C8.82098 7.425 8.64929 7.49612 8.5227 7.6227C8.39612 7.74929 8.325 7.92098 8.325 8.1V13.5C8.325 13.8726 8.6274 14.175 9 14.175ZM9 4.5C9.23869 4.5 9.46761 4.59482 9.6364 4.7636C9.80518 4.93239 9.9 5.1613 9.9 5.4C9.9 5.63869 9.80518 5.86761 9.6364 6.0364C9.46761 6.20518 9.23869 6.3 9 6.3C8.7613 6.3 8.53239 6.20518 8.3636 6.0364C8.19482 5.86761 8.1 5.63869 8.1 5.4C8.1 5.1613 8.19482 4.93239 8.3636 4.7636C8.53239 4.59482 8.7613 4.5 9 4.5Z" fill="white"/>
                            </svg>
                            <div><span className='text-[#FFFFFF99]'>Вес: </span>{data?.measure} {data?.measure_unit}</div>
                          </div>
                          <div className='w-[60px] h-[26px] bg-white rounded-[25px] text-black text-[14px] flex items-center text-center justify-center'>100 гр</div>
                        </div>
                        {data?.nutrients &&
                          <>
                            {data?.nutrients.length > 0 &&
                              <>
                                <div className='w-full h-[1px] bg-[#FFFFFF26] mt-[8px]' />
                                <div className='flex items-center justify-between mt-[8px] leading-none'>
                                  <div>
                                    <div className='font-medium text-white text-[22px]'>{data?.nutrients[0]?.calories}</div>
                                    <div className='text-[#FFFFFF99] text-[14px]'>Ккал</div>
                                  </div>
                                  <div>
                                    <div className='font-medium text-white text-[22px]'>{data?.nutrients[0]?.proteins}</div>
                                    <div className='text-[#FFFFFF99] text-[14px]'>Белки</div>
                                  </div>
                                  <div>
                                    <div className='font-medium text-white text-[22px]'>{data?.nutrients[0]?.fat}</div>
                                    <div className='text-[#FFFFFF99] text-[14px]'>Жиры</div>
                                  </div>
                                  <div>
                                    <div className='font-medium text-white text-[22px]'>{data?.nutrients[0]?.carbohydrates}</div>
                                    <div className='text-[#FFFFFF99] text-[14px]'>Углеводы</div>
                                  </div>
                                </div>
                              </>
                            }
                          </>
                        }
                      </div>
                    )}
                  </div>
                }
                <button
                  onClick={() => changeFavorite( data?.id )}
                  className={`w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center flex-none shadow-lg ${
                    favorite.includes( data?.id ) ? 'text-[#F66116]' : 'text-[#C9C9C9]' 
                  }`}
                >
                  <Like />
                </button>
              </div>
            </div>
            
            {product?.loading ?
              <div className="flex items-center justify-center h-[calc(100dvh-80px)]">
                <div className="w-10 h-10 border-4 border-[#5A91FF] border-t-transparent rounded-full animate-spin"></div>
              </div>
            :
              <>
                <div className='flex items-center justify-center flex-auto w-[calc(100%+20px)] ml-[-10px] z-0 relative'>
                  <img className='max-w-[100%] h-[auto]' src={data?.image} width={522} height={444} alt={data?.pagetitle} />
                </div>
                {(hasIngredients || hasAntiIngredients) &&
                  <div className='w-[100%] flex justify-center'>
                    <div
                      className='flex items-center gap-[9px] h-[40px] p-[5px] rounded-full cursor-pointer bg-white mt-[-26px] mb-[20px] z-10 relative shadow-md'
                      onClick={this.openIngredientsModal}
                    >
                      <div className='flex flex-none items-center justify-center w-[30px] h-[30px] rounded-full bg-[#F6F6F6] text-black'>
                        <Edit />
                      </div>
                      <div className='text-[16px] me-[12px] text-nowrap tracking-tight text-black'>
                        {ingredientiLimit > 0 && this.getSelectedIngredientsTotalQuantity() > 0
                          ? `Ингредиенты (${this.getSelectedIngredientsTotalQuantity()}/${ingredientiLimit})`
                          : (hasIngredients ? 'Добавить ингредиенты' : 'Можно убрать')
                        }
                      </div>
                      <div className='absolute top-[-19px] right-[32px] w-[17px] h-auto'>
                        <Bubbles />
                      </div>
                    </div>
                  </div>
                }
                <div className="w-full mt-auto">
                  <div
                    className="w-full mt-[10px] relative"
                    style={{
                      borderRadius: '0px',
                      borderTopLeftRadius: '25px',
                      borderTopRightRadius: '25px',
                      paddingTop: '22px',
                      paddingBottom: '15px',
                      backgroundColor: '#FFFFFF',
                      border: 'none',
                      marginLeft: '-10px',
                      width: 'calc(100% + 20px)',
                      boxShadow: '0px -2px 31.2px 0px #00000017'
                    }}
                  >
                    {data?.metka?.name != `` &&
                      <div className='absolute w-[100%] top-[-12px] left-0 flex justify-center'>
                        <div
                          style={{ backgroundColor: data?.metka?.color }}
                          className='h-[24px] rounded-full px-[10px] metka-shadow text-white text-[12px] flex items-center'
                        >
                          {data?.metka?.name}
                        </div>
                      </div>
                    }
                    <div className='w-[100%] text-center text-[#00000099] text-[14px]'>{data?.parent}</div>
                    <div className='w-[100%] text-center text-black text-[22px] px-[10px] leading-tight'>{data?.pagetitle}</div>
                    {data?.vars?.length > 1 &&
                      <div className='flex justify-center mt-[10px]'>
                        <div className='p-[3px] rounded-[20px] flex items-center gap-[5px] bg-[#F6F6F6] backdrop-blur-[30px] text-[12px] mt-[10px] mx-[15px]'>
                          {data.vars.map( ( elm, k ) => {
                            if(data?.id == elm?.id) return (
                              <div className='rounded-[30px] h-[34px] w-[73px] flex items-center justify-center text-[14px] text-center bg-white text-black' key={k}>
                                {elm?.name}
                              </div>
                            )
                            return (
                              <div className='rounded-[30px] h-[34px] w-[73px] flex items-center justify-center text-[14px] text-center text-[#00000080] cursor-pointer' onClick={() => this.changeProduct(elm?.id)} key={k}>
                                {elm?.name}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    }
                    {data?.introtext != `` &&
                      <div className='leading-none p-[15px] relative rounded-[20px] items-center justify-between bg-[#F6F6F6] backdrop-blur-[30px] text-black text-center text-[14px] mt-[20px] mx-[15px]'>
                        <div>{data?.introtext}</div>
                        {data?.metka?.icon == `paper` &&
                          <div className='absolute top-[-12px] right-[calc(50%-15px)]'><Paper /></div>
                        }
                        {data?.metka?.icon == `leaf` &&
                          <div className='absolute top-[-12px] right-[calc(50%-15px)]'><Leaf /></div>
                        }
                      </div>
                    }
                    {data?.parent_introtext != `` &&
                      <div className='leading-none p-[10px] rounded-[20px] bg-[#F87605] text-white text-[14px] mt-[5px] mx-[15px] text-center'>
                        {data?.parent_introtext}
                      </div>
                    }
                    <div className='flex flex-col items-center justify-between gap-[10px] mx-[15px] mt-[14px]'>

                      {/* Блок выбора ингредиента из vibor */}
                      {hasVibor && (
                        <div className='w-[100%]'>
                          <div className='text-[16px] text-black mb-[10px] text-center'>Выберите соус</div>
                          <div className='flex gap-[10px] overflow-x-auto justify-center pb-[5px]'>
                            {data.vibor.map((item, index) => (
                              <div
                                key={item.id || index}
                                className={`flex-none h-[45px] px-[15px] rounded-[20px] flex items-center gap-[8px] cursor-pointer ${
                                  selectedVibor?.id === item.id 
                                    ? 'bg-[#5A91FF] text-white' 
                                    : 'bg-[#F6F6F6] text-black'
                                }`}
                                onClick={() => this.handleViborChange(item)}
                              >
                                <div className="text-[14px] whitespace-nowrap">{item.name}</div>
                                {item.price > 0 && (
                                  <div className="text-[12px] opacity-80">+{item.price}₽</div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Блок выбора ингредиента из vibor_mas */}
                      {hasViborMas && data.vibor_mas.map((group, groupIndex) => {
                        const selectedItem = selectedViborMas[group.name] 
                          ? Object.keys(selectedViborMas[group.name])[0]
                          : null;

                        return (
                          <div key={groupIndex} className='w-[100%]'>
                            <div className='text-[16px] text-black mb-[10px] text-center'>{group.name}</div>
                            <div className='flex flex-wrap gap-[10px] overflow-x-auto justify-center pb-[5px]'>
                              {group.list.map((item, itemIndex) => (
                                <div
                                  key={item.id || itemIndex}
                                  className={`flex-none h-[25px] px-[10px] rounded-[13px] flex items-center gap-[8px] cursor-pointer ${
                                    selectedItem === item.id.toString()
                                      ? 'bg-[#5A91FF] text-white' 
                                      : 'bg-[#F6F6F6] text-black'
                                  }`}
                                  onClick={() => this.handleViborMasChange(group.name, item)}
                                >
                                  <div className="text-[14px] whitespace-nowrap">{item.name}</div>
                                  {item.price > 0 && (
                                    <div className="text-[12px] opacity-80">+{item.price}₽</div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })}

                      {/* Блок «Можно убрать» — антиингредиенты */}
                      {hasAntiIngredients && (
                        <div className='w-[100%]'>
                          <div className='text-[16px] text-black mb-[10px] text-center'>Можно убрать</div>
                          <div className='flex flex-wrap gap-[10px] justify-center pb-[5px]'>
                            {antiingredients.map((ingredient, index) => {
                              const isSelected = selectedAntiIngredients.hasOwnProperty(ingredient.id.toString());
                              return (
                                <div
                                  key={ingredient.id || index}
                                  className={`flex-none h-[35px] px-[15px] rounded-[20px] flex items-center gap-[8px] cursor-pointer ${
                                    isSelected ? 'bg-[#5A91FF] text-white' : 'bg-[#F6F6F6] text-black'
                                  }`}
                                  onClick={() => this.toggleAntiIngredient(ingredient.id)}
                                >
                                  <div className="text-[14px] whitespace-nowrap">{ingredient.name}</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className='flex w-[100%] rounded-[30px] bg-[#F6F6F6] h-[50px] items-center justify-between p-[5px]'>
                        <button 
                          onClick={this.decrementQuantity}
                          className="w-[40px] h-[40px] flex items-center justify-center"
                          disabled={quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path 
                              d="M1 1L11.5 1" 
                              stroke={quantity <= 1 ? "#C9C9C9" : "black"} 
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                        <div className='text-[16px] font-normal text-center'>
                          {quantity} шт
                        </div>
                        <button 
                          onClick={this.incrementQuantity}
                          className="w-[40px] h-[40px] flex items-center justify-center"
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                            <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                          </svg>
                        </button>
                      </div>
                      <div 
                        className="flex flex-1 w-[100%] items-center gap-[9px] h-[50px] p-[5px] rounded-full cursor-pointer bg-[#5A91FF] bluebtn-shadow"
                        onClick={this.handleAddToCart}
                      >
                        <div className='flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#FFFFFF40]'>
                          <Bag />
                        </div>
                        <div className='text-[16px] flex flex-1 items-center justify-around gap-[5px] me-[12px] text-nowrap tracking-tight text-white'>
                          <div className='flex items-center gap-[8px]'>
                            <div>Добавить в корзину</div>
                            <div> · </div>
                            <div>{price} ₽</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
          </div>
        </div>

        {/* Модальное окно ингредиентов */}
        <div className={`bg-[#00000066] backdrop-blur-[51.4px] z-[60] fixed top-0 w-[100%] h-dvh overflow-y-auto transition-all duration-300 ease-in-out ${showIngredientsModal ? ` left-0` : ` left-[-100%]`}`}>
          <div className='container h-dvh flex flex-col tracking-tight px-[20px]'>
            <div className="flex justify-between items-center mt-[20px]">
              <button
                onClick={this.closeIngredientsModal}
                className="w-[40px] h-[40px] rounded-full bg-[#F6F6F6] flex items-center justify-center flex-none text-black relative z-10"
              >
                <Close />
              </button>
              <div></div>
            </div>
            <div className="text-center mt-[-40px]">
              <div className="text-light text-[14px]">{data?.parent}</div>
              <div className="text-light text-[22px]">{data?.pagetitle}</div>
            </div>
            <div className="mx-auto mt-[10px] px-[17px] h-[30px] flex flex-none items-center justify-center gap-[5px] bg-[#FFFFFF33] rounded-[25px]">
              <Info2 />
              <div className='text-white text-[14px]'><span className='text-[#FFFFFF99]'>Вес:</span> {data?.measure}</div>
            </div>
            
            {/* Блок выбора ингредиента из vibor в модальном окне */}
            {hasVibor && (
              <>
                <div className="text-white text-[22px] font-medium mt-[31px]">Выберите соус</div>
                <div className="mt-[15px] w-[100%] flex gap-[10px] overflow-x-auto pb-[5px]">
                  {data.vibor.map((item, index) => (
                    <div
                      key={item.id || index}
                      className={`flex-none h-[45px] px-[15px] rounded-[20px] flex items-center gap-[8px] cursor-pointer ${
                        selectedVibor?.id === item.id
                          ? 'bg-[#5A91FF] text-white'
                          : 'bg-[#FFFFFF33] text-white'
                      }`}
                      onClick={() => this.handleViborChange(item)}
                    >
                      <div className="text-[14px] whitespace-nowrap">{item.name}</div>
                      {item.price > 0 && (
                        <div className="text-[12px] opacity-80">+{item.price}₽</div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
            
            {/* Блок выбора ингредиента из vibor_mas в модальном окне */}
            {hasViborMas && data.vibor_mas.map((group, groupIndex) => {
              const selectedItem = selectedViborMas[group.name]
                ? Object.keys(selectedViborMas[group.name])[0]
                : null;

              return (
                <div key={groupIndex}>
                  <div className="text-white text-[22px] font-medium mt-[31px]">{group.name}</div>
                  <div className="mt-[15px] w-[100%] flex flex-wrap gap-[10px] overflow-x-auto pb-[5px]">
                    {group.list.map((item, itemIndex) => (
                      <div
                        key={item.id || itemIndex}
                        className={`flex-none h-[25px] px-[10px] rounded-[13px] flex items-center gap-[8px] cursor-pointer ${
                          selectedItem === item.id.toString()
                            ? 'bg-[#5A91FF] text-white'
                            : 'bg-[#FFFFFF33] text-white'
                        }`}
                        onClick={() => this.handleViborMasChange(group.name, item)}
                      >
                        <div className="text-[14px] whitespace-nowrap">{item.name}</div>
                        {item.price > 0 && (
                          <div className="text-[12px] opacity-80">+{item.price}₽</div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
            
            {/* Индикатор лимита ингредиентов */}
            {ingredientiLimit > 0 && (
              <div className="text-white text-[14px] mt-[15px] opacity-70">
                Можно добавить до {ingredientiLimit} шт. ингредиентов. Выбрано: {this.getSelectedIngredientsTotalQuantity()}
              </div>
            )}

            {/* Доступные для добавления ингредиенты */}
            <div className="text-white text-[22px] font-medium mt-[15px]">Добавьте ингредиенты</div>
            <div className="mt-[15px] w-[100%] flex gap-[5px] flex-wrap">
              {/* Сначала показываем выбранные ингредиенты с контролами количества */}
              {selectedIngredientObjects.map(ingredient => {
                return (
                  <div
                    key={ingredient.id}
                    className='h-[45px] flex-none px-[3px] rounded-[20px] bg-[#FFFFFF33] flex items-center gap-[8px] overflow-x-auto'
                  >
                    <div className="h-[35px] w-[35px] bg-white rounded-full flex items-center justify-center">
                      {ingredient.icon != `` &&
                        <img
                          src={ingredient.icon}
                          alt={ingredient.name}
                          width='20' height='20'
                          className='max-w-[90%] max-h-[90%]'
                        />
                      }
                    </div>
                    <div className="text-[14px] text-white">{ingredient.name}</div>
                    <div className="h-[39px] px-[3px] flex items-center gap-[10px] text-[#00000099] text-[12px] bg-white rounded-full">
                      <div className='ml-[10px]'>{ingredient.price * ingredient.quantity}₽</div>
                      <div className='w-[4px] h-[4px] rounded-full bg-[#00000026]' />
                      {ingredient.quantity > 1 &&
                        <button
                          onClick={() => this.decrementIngredientQuantity(ingredient.id)}
                          className='w-[33px] h-[33px] rounded-full bg-[#F6F6F6] flex items-center justify-center'
                          disabled={ingredient.quantity <= 1}
                        >
                          <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M1 1L11.5 1"
                              stroke={ingredient.quantity <= 1 ? "#C9C9C9" : "black"}
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                      }
                      <div>{ingredient.quantity} шт</div>
                      {(!isLimitReached || ingredientiLimit <= 0) &&
                        <button
                          onClick={() => this.incrementIngredientQuantity(ingredient.id)}
                          className='w-[33px] h-[33px] rounded-full bg-[#F6F6F6] flex items-center justify-center'
                        >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                            <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                )
              })}
              
              {/* Затем доступные ингредиенты */}
              {availableIngredients.map( ( ingredient, k ) => {
                if(!show_all && k > 5) return ''
                const isDisabled = isLimitReached && ingredientiLimit > 0;
                return (
                  <div
                    key={ingredient.id}
                    className={`h-[45px] flex-none px-[3px] rounded-[20px] bg-[#FFFFFF33] flex items-center gap-[8px] overflow-x-auto ${isDisabled ? '' : 'cursor-pointer'}`}
                    onClick={() => {
                      if (!isDisabled) this.toggleIngredient(ingredient.id.toString());
                    }}
                    style={{ opacity: isDisabled ? 0.4 : 1 }}
                  >
                    <div className="h-[35px] w-[35px] bg-white rounded-full flex items-center justify-center">
                      {ingredient.icon != `` &&
                        <img
                          src={ingredient.icon}
                          alt={ingredient.name}
                          width='20' height='20'
                          className='max-w-[90%] max-h-[90%]'
                        />
                      }
                    </div>
                    <div className="text-[14px] text-white">{ingredient.name}</div>
                    <div className="h-[39px] px-[10px] flex items-center text-[#00000099] text-[12px] bg-white rounded-full">{ingredient.price}₽</div>
                  </div>
                )
              })}

              {/* Если нет ни выбранных, ни доступных ингредиентов */}
              {selectedIngredientObjects.length === 0 && availableIngredients.length === 0 && (
                <div className="text-white text-center w-full">Нет доступных ингредиентов</div>
              )}
            </div>
            {availableIngredients.length > 6 && !show_all &&
              <div onClick={() => this.showAll()} className='text-center text-[16px] text-white mt-[15px] cursor-pointer flex items-center justify-center gap-[7px]'>
                <div>Показать все</div>
                <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L4.5 4.5L8 1" stroke="white" strokeLinecap="round"/>
                </svg>
              </div>
            }

            {/* Блок «Можно убрать» — антиингредиенты */}
            {hasAntiIngredients && (
              <>
                <div className="text-white text-[22px] font-medium mt-[30px]">Можно убрать</div>
                <div className="mt-[15px] w-[100%] flex gap-[5px] flex-wrap">
                  {antiingredients.map((ingredient, index) => {
                    const isSelected = selectedAntiIngredients.hasOwnProperty(ingredient.id.toString());
                    return (
                      <div
                        key={ingredient.id || index}
                        className={`h-[40px] flex-none px-[15px] rounded-[20px] flex items-center gap-[8px] overflow-x-auto text-white cursor-pointer ${
                          isSelected ? 'bg-[#5A91FF]' : 'bg-[#FFFFFF33]'
                        }`}
                        onClick={() => this.toggleAntiIngredient(ingredient.id)}
                      >
                        <div className="text-[14px]">{ingredient.name}</div>
                        {isSelected && <Close />}
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {/* Выбранные ингредиенты для удаления */}
            {selectedIngredientObjects.length > 0 && (
              <>
                <div className="text-white text-[22px] font-medium mt-[30px]">Убрать ингредиенты</div>
                <div className="mt-[15px] w-[100%] flex gap-[5px] flex-wrap">
                  {selectedIngredientObjects.map(ingredient => {
                    return (
                      <div
                        key={ingredient.id}
                        className='h-[40px] flex-none px-[15px] rounded-[20px] bg-[#FFFFFF33] flex items-center gap-[8px] overflow-x-auto text-white cursor-pointer'
                        onClick={() => this.toggleIngredient(ingredient.id.toString())}
                      >
                        <div className="text-[14px]">{ingredient.name}</div>
                        <Close />
                      </div>
                    )
                  })}
                </div>
              </>
            )}

            <div className='flex flex-col items-center justify-between gap-[10px] mt-auto pb-[15px] pt-[15px]'>
              <div className='flex rounded-[30px] bg-[#F6F6F6] h-[50px] w-[100%] items-center justify-between p-[5px]'>
                <button
                  onClick={this.decrementQuantity}
                  className="w-[40px] h-[40px] flex items-center justify-center"
                  disabled={quantity <= 1}
                >
                  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 1L11.5 1"
                      stroke={quantity <= 1 ? "#C9C9C9" : "black"}
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <div className='text-[16px] font-normal text-center'>
                  {quantity} шт
                </div>
                <button
                  onClick={this.incrementQuantity}
                  className="w-[40px] h-[40px] flex items-center justify-center"
                >
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                    <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
              <div
                className="flex flex-1 items-center gap-[9px] h-[50px] p-[5px] rounded-full cursor-pointer bg-[#5A91FF] bluebtn-shadow w-[100%]"
                onClick={this.handleAddToCart}
              >
                <div className='flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#FFFFFF40]'>
                  <Bag />
                </div>
                <div className='text-[16px] flex flex-1 items-center justify-around gap-[5px] me-[12px] text-nowrap tracking-tight text-white'>
                  <div className='flex items-center gap-[8px]'>
                    <div>Добавить в корзину</div>
                    <div> · </div>
                    <div>{price} ₽</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Оверлей для закрытия окна информации при клике вне его */}
        {showInfoModal && (
          <div
            className="fixed inset-0 z-40"
            onClick={this.closeInfoModal}
          />
        )}
      </>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  product: PropTypes.object,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  openProductWin: PropTypes.func,
  closeProductWin: PropTypes.func,
  addToCart: PropTypes.func
}

export default Main
